import { useEffect } from "react";

const GCAL_SLOTS_CSS = `${process.env.PUBLIC_URL || ""}/gcal-slots-official.css`;

export function useGcalOfficialStyles() {
  useEffect(() => {
    const links = [];

    const ensureLink = (id, href) => {
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      links.push(link);
    };

    ensureLink(
      "gcal-official-slots-css",
      GCAL_SLOTS_CSS,
    );
    ensureLink(
      "gcal-official-slots-css-remote",
      "https://www.gstatic.com/_/mss/boq-calendar/_/ss/k=boq-calendar.CalendarWebAppSlots.nYBeq9-9Vug.L.B1.O/am=AEQAgAEAKgBA/d=1/rs=AA4Gz9ilP9q4Jv7dbHf8VlCh9vJMqzpnqg",
    );
    ensureLink(
      "gcal-google-material-icons",
      "https://fonts.googleapis.com/icon?family=Material+Icons",
    );
    ensureLink(
      "gcal-appointments-overrides-css",
      `${process.env.PUBLIC_URL || ""}/gcal-appointments-overrides.css`,
    );

    return () => {
      links.forEach((el) => el.remove());
    };
  }, []);
}
